var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentityInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6325 0H1.73978C0.793415 0 0 0.745619 0 1.73978V16.2602C0 17.2066 0.745619 18 1.73978 18H21.6277C22.5741 18 23.3675 17.2066 23.3675 16.2124V1.73978C23.3723 0.798194 22.6267 0 21.6325 0ZM22.4259 16.2076C22.4259 16.6569 22.077 17.0011 21.6325 17.0011H1.73978C1.29049 17.0011 0.946362 16.6522 0.946362 16.2076V1.73978C0.946362 1.29049 1.29527 0.946362 1.73978 0.946362H21.6277C22.077 0.946362 22.4211 1.29527 22.4211 1.73978V16.2076H22.4259Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95669 3.18359H2.78516V8.35513H7.95669V3.18359ZM7.01033 7.40877H3.77931V4.17775H7.01033V7.40877Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5757 10.8398H3.28516V11.834H13.5757V10.8398Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5757 13.9688H3.28516V14.9629H13.5757V13.9688Z",
    fill: "#828282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityInfo);
export default __webpack_public_path__ + "static/media/IdentityInfo.87cd39586978980185937e3b895efc19.svg";
export { ForwardRef as ReactComponent };